import { Stack, Typography, useTheme } from '@mui/material';

import { Accordion } from '@/components/Accordion/Accordion';
import { PopperContent } from '@/components/poppers/PopperContent';
import { ContextualHelpTooltip } from '@/modules/content/components/ContextualHelpTooltip';
import { EstateTrustEntityCard } from '@/modules/estate/EstateTrusts/TrustContainer/EstateTrustEntityCard/EstateTrustEntityCard';
import { EstatePage_EntityFragment } from '@/modules/estate/graphql/EstatePageData.generated';

export interface DraftGRATsContainerProps {
  draftEntities: EstatePage_EntityFragment[];
}

export function DraftGRATsContainer({
  draftEntities,
}: DraftGRATsContainerProps) {
  const theme = useTheme();

  return (
    <Accordion
      variant="filled"
      withDivider={false}
      isDefaultExpanded
      title={
        <Stack direction="row" alignItems="center" gap={1}>
          <Typography variant="title-s">Draft GRATs</Typography>
          <ContextualHelpTooltip>
            <PopperContent
              sx={{
                maxWidth: theme.spacing(50),
              }}
              body={'GRATs that have not yet been fully implemented.'}
            />
          </ContextualHelpTooltip>
        </Stack>
      }
    >
      <EstateTrustEntityCard trusts={draftEntities} variant="draft_grats" />
    </Accordion>
  );
}
